import React, { useContext } from 'react';
import { AdsContext } from '@src/context/ads';
import Somtag, { SomtagProps } from '@src/components/Ad/Somtag';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';

const SomtagParagraph = ({ paragraph }: ParagraphProps) => {
  const { somtagInitialized } = useContext(AdsContext);

  const component: SomtagProps = {
    id: paragraph.id,
    slot: paragraph.data.slot,
    display: paragraph.data.display,
    type: 'somtag',
    className: 'paragraph somtag-paragraph',
  };
    return somtagInitialized
    ? <Somtag {...component} routeAware />
    : null;
};

export default SomtagParagraph;
